export const ADD_FUND_STRUCTURE = "ADD_FUND_STRUCTURE";
export const ADD_FUND_STRUCTURE_SUCCESS = "ADD_FUND_STRUCTURE_SUCCESS";
export const ADD_FUND_STRUCTURE_FAILURE = "ADD_FUND_STRUCTURE_FAILURE";
export const ADD_FUND_STRUCTURE_RESET = "ADD_FUND_STRUCTURE_RESET";
export const EDIT_FUND_STRUCTURE = "EDIT_FUND_STRUCTURE";
export const EDIT_FUND_STRUCTURE_RESET = "EDIT_FUND_STRUCTURE_RESET";
export const EDIT_FUND_STRUCTURE_SUCCESS = "EDIT_FUND_STRUCTURE_SUCCESS";
export const EDIT_FUND_STRUCTURE_FAILURE = "EDIT_FUND_STRUCTURE_FAILURE";
